/**
 * 认证上下文 - 管理登录状态，提供全局用户信息
 */
import React, { createContext, useContext, useState, useEffect } from 'react';
import { authApi, cartApi } from '../api';
import { v4 as uuidv4 } from 'uuid';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // 初始化：从 localStorage 恢复登录状态
  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    const token = localStorage.getItem('accessToken');
    if (storedUser && token) {
      setUser(JSON.parse(storedUser));
    }
    // 确保匿名用户有 sessionId
    if (!localStorage.getItem('sessionId')) {
      localStorage.setItem('sessionId', uuidv4());
    }
    setLoading(false);
  }, []);

  /** 登录 */
  const login = async (payload) => {
    const data = await authApi.login(payload);
    localStorage.setItem('accessToken', data.accessToken);
    localStorage.setItem('refreshToken', data.refreshToken);
    localStorage.setItem('user', JSON.stringify(data.user));
    setUser(data.user);
    // 合并匿名购物车
    try { await cartApi.mergeCart(); } catch {}
    return data.user;
  };

  /** 注册 */
  const register = async (formData) => {
    const data = await authApi.register(formData);
    localStorage.setItem('accessToken', data.accessToken);
    localStorage.setItem('refreshToken', data.refreshToken);
    localStorage.setItem('user', JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  /** 退出登录 */
  const logout = async () => {
    try { await authApi.logout(); } catch {}
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('user');
    setUser(null);
  };

  const isAdmin = user?.role === 'admin';
  const isLoggedIn = !!user;

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, isAdmin, isLoggedIn }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
